import { Flex } from "@chakra-ui/react";

const AuthenticationView = () => {
  return <Flex direction="column"></Flex>;
};

export default AuthenticationView;
